import { CountryFlagType, CountrySwitcherOption } from '@cdaas/reusable-components-daas';
import { Country, LocaleResponse } from '@cdaas/api-clients/dist/product-service-openapi';
import { Denmark, Estonia, Finland, Norway, Sweden, UnitedKingdom } from './countries';

export interface Language {
  /**
   * Language name in English.
   * @type {string}
   * @memberof Language
   */
  name: string;
  /**
   * Language name in its own language.
   * @type {string}
   * @memberof Language
   */
  native_name: string;
  /**
   * Language tag in IETF BCP 47.
   * @type {string}
   * @memberof Language
   */
  tag: string;
}

export const defaultLocale: LocaleResponse = {
  id: 0,
  language_tag: 'en',
  name: 'English - default',
  name_in_native_language: 'English',
};

export const availableLocales: Language[] = [
  {
    tag: 'da-DK',
    name: 'Danish (Denmark)',
    native_name: 'dansk (Danmark)',
  },
  {
    tag: 'en',
    name: 'English',
    native_name: 'English',
  },
  {
    tag: 'fi-FI',
    name: 'Finnish (Finland)',
    native_name: 'suomi (Suomi)',
  },
  {
    tag: 'no-NO',
    name: 'Norwegian (Norway)',
    native_name: 'norsk (Norge)',
  },
  {
    tag: 'sv-SE',
    name: 'Swedish (Sweden)',
    native_name: 'svenska (Sverige)',
  },
];

export const getLanguageFromLocaleName = (name?: LocaleResponse['name']) => name?.replace(/\s\(.*\)/, '');

export const getLocaleFromLanguage = (language: Language): LocaleResponse => ({
  id: 0,
  name: language.name,
  name_in_native_language: language.native_name,
  language_tag: language.tag,
});

export const getCountryOptions = (countries: Country[]): CountrySwitcherOption[] => {
  interface countryFlagMap {
    [index: string]: CountryFlagType;
  }
  const flags = {} as countryFlagMap;
  flags[Estonia.code] = 'est';
  flags[Finland.code] = 'fin';
  flags[Denmark.code] = 'den';
  flags[Norway.code] = 'nor';
  flags[Sweden.code] = 'swe';
  flags[UnitedKingdom.code] = 'uk';

  return countries.map(country => {
    const { id, name, code } = country;
    return {
      value: String(id),
      label: name,
      countryFlag: flags[code],
    };
  });
};
